// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__TQ2wp","icon":"footer_icon__paoaz","share":"footer_share__yX8Lg","copyright":"footer_copyright__B+UOK"};